import SchemaPropTypes from '@get-bridge/learn-legacy-shared/dist/shared/SchemaPropTypes';
const { oneOf, shape, string } = SchemaPropTypes;

export default shape({
  id: string,
  settings: shape({
    goalTerminology: oneOf(['GOAL', 'OKR']),
  }),
});



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/perform_settings/schemas/PerformSettingsPayload.js